import { render, staticRenderFns } from "./icons.vue?vue&type=template&id=560e227a&scoped=true&"
import script from "./icons.vue?vue&type=script&lang=js&"
export * from "./icons.vue?vue&type=script&lang=js&"
import style0 from "./icons.vue?vue&type=style&index=0&id=560e227a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560e227a",
  null
  
)

export default component.exports